import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { any, number, nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

const nullableString = anyOf(string, nullOrUndefined);
const nullableNumber = anyOf(number, nullOrUndefined);

const conversationUser = objectOf({
  id: string,
  display_name: nullableString,
  email: nullableString,
  external_id: nullableString,
});

const conversationDeveloper = objectOf({
  id: string,
  display_name: nullableString,
  email: nullableString,
});

const conversationSummary = objectOf({
  id: string,
  user_id: string,
  status: string,
  started_at: nullableNumber,
  last_activity_at: nullableNumber,
  user: conversationUser,
  previewed_by: anyOf(conversationDeveloper, nullOrUndefined),
});

const conversationMessageEvent = objectOf({
  id: string,
  type: string,
  role: string,
  content: string,
  timestamp: nullableNumber,
});

const conversationToolEvent = objectOf({
  id: string,
  type: string,
  name: nullableString,
  tool_type: string,
  subject: nullableString,
  arguments: any,
  result: nullableString,
  timestamp: nullableNumber,
});

const conversationEvent = anyOf(conversationMessageEvent, conversationToolEvent);

export const isConversationHistoryListResult = objectOf({
  hits: number,
  results: arrayOf(conversationSummary),
});

export const isConversationHistoryDetailResult = objectOf({
  result: objectOf({
    id: string,
    user_id: string,
    status: string,
    started_at: nullableNumber,
    last_activity_at: nullableNumber,
    user: conversationUser,
    previewed_by: anyOf(conversationDeveloper, nullOrUndefined),
    events: arrayOf(conversationEvent),
  }),
  next_cursor: nullableString,
});
